import { render } from "./LoadingStandings.vue?vue&type=template&id=6e1f6a24&scoped=true"
import script from "./LoadingStandings.vue?vue&type=script&lang=js"
export * from "./LoadingStandings.vue?vue&type=script&lang=js"

import "../../assets/css/loading/index.css?vue&type=style&index=0&id=6e1f6a24&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1f6a24"]])

export default __exports__